import {
  GET_GLOBAL_IAAC,
  GET_GLOBAL_IAAC_SUCCESSFUL,
  GET_GLOBAL_IAAC_FAILURE,
  PUT_GLOBAL_IAAC,
  PUT_GLOBAL_IAAC_SUCCESSFUL,
  PUT_GLOBAL_IAAC_FAILURE,
  CLEAR_ALL_GLOBAL_IAAC_MESSAGES,
  CLEAR_ALL_GLOBAL_IAAC_MESSAGES_SUCCESSFUL
} from "./actionTypes";

export const getGlobalIaac = (orgCode) => {
  console.log("getGlobalIaac action");
  return {
    type: GET_GLOBAL_IAAC,
    payload: { orgCode } 
  };
}

export const getGlobalIaacSuccessful = (iaac) => {
  console.log("getGlobalIaacSuccessful action, iaac:", iaac);
  return {
    type: GET_GLOBAL_IAAC_SUCCESSFUL,
    payload: { iaac },
  };
}

export const getGlobalIaacFailure = (getGlobalIaacError) => {
  console.log("getGlobalIaacFailure action, error:", getGlobalIaacError);
  return {
    type: GET_GLOBAL_IAAC_FAILURE,
    payload: { getGlobalIaacError },
  };
}

export const putGlobalIaac = (iaac) => {
  console.log("putGlobalIaac action, iaac: ", iaac);
  return {
    type: PUT_GLOBAL_IAAC,
    payload: { iaac }
  };
}

export const putGlobalIaacSuccessful = (updateGlobalIaacMessage) => {
  console.log("putGlobalIaacSuccessful action, updateGlobalIaacMessage: ", updateGlobalIaacMessage);
  return {
    type: PUT_GLOBAL_IAAC_SUCCESSFUL,
    payload: { updateGlobalIaacMessage }
  }
}

export const putGlobalIaacFailure = (updateGlobalIaacError) => {
  console.log("putGlobalIaacFailure action, error: ", updateGlobalIaacError);
  return {
    type: PUT_GLOBAL_IAAC_FAILURE,
    payload: { updateGlobalIaacError }
  }
}

export const clearAllGlobalIaacMessages = () => {
  return {
    type: CLEAR_ALL_GLOBAL_IAAC_MESSAGES,
    payload: {},
  };
};

export const clearAllGlobalIaacMessagesSuccessful = () => {
  return {
    type: CLEAR_ALL_GLOBAL_IAAC_MESSAGES_SUCCESSFUL,
    payload: {},
  };
};